var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoTableToDisplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3236_4714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.378 183.198H170.329V166.917H193.134C193.364 166.917 193.551 166.729 193.551 166.499C193.551 166.269 193.364 166.082 193.134 166.082H149.455V150.26H184.117C184.347 150.26 184.535 150.073 184.535 149.843C184.535 149.613 184.347 149.426 184.117 149.426H87.1788C86.9487 149.426 86.7615 149.613 86.7615 149.843C86.7615 150.073 86.9487 150.26 87.1788 150.26H109.305V166.082H70.4173C70.1872 166.082 70 166.269 70 166.499C70 166.729 70.1872 166.917 70.4173 166.917H131.393V183.198H78.8136C78.5835 183.198 78.3964 183.386 78.3964 183.616C78.3964 183.846 78.5835 184.033 78.8136 184.033H93.0968V199.648H86.9702C86.7401 199.648 86.5529 199.835 86.5529 200.065C86.5529 200.295 86.7401 200.483 86.9702 200.483H141.053C141.283 200.483 141.47 200.295 141.47 200.065C141.47 199.835 141.283 199.648 141.053 199.648H110.139V184.033H148.623V200.065C148.623 200.295 148.81 200.483 149.04 200.483C149.27 200.483 149.457 200.295 149.457 200.065V184.033H206.379C206.61 184.033 206.797 183.846 206.797 183.616C206.797 183.386 206.61 183.198 206.379 183.198H206.378ZM110.137 150.26H148.621V166.082H110.137V150.26ZM132.226 166.915H169.495V183.196H132.226V166.915ZM109.303 199.646H93.9294V184.031H109.303V199.646Z",
    fill: "#E9EAFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.82227 16.0875H40.1991V31.369H11.7926C11.5625 31.369 11.3754 31.5562 11.3754 31.7863C11.3754 32.0164 11.5625 32.2036 11.7926 32.2036H16.8956V47.8186H11.7926C11.5625 47.8186 11.3754 48.0058 11.3754 48.2359C11.3754 48.466 11.5625 48.6531 11.7926 48.6531H40.1991V64.935H9.69063C9.46054 64.935 9.27333 65.1222 9.27333 65.3523C9.27333 65.5824 9.46054 65.7695 9.69063 65.7695H56.2138V81.5912H34.088C33.8579 81.5912 33.6708 81.7784 33.6708 82.0085C33.6708 82.2386 33.8579 82.4258 34.088 82.4258H144.467C144.697 82.4258 144.885 82.2386 144.885 82.0085C144.885 81.7784 144.697 81.5912 144.467 81.5912H135.685V65.7695H174.432C174.662 65.7695 174.849 65.5824 174.849 65.3523C174.849 65.1222 174.662 64.935 174.432 64.935H155.344V48.6531H187.676C187.906 48.6531 188.093 48.466 188.093 48.2359C188.093 48.0058 187.906 47.8186 187.676 47.8186H174.849V32.2036H212.798C213.028 32.2036 213.216 32.0164 213.216 31.7863C213.216 31.5562 213.028 31.369 212.798 31.369H197.975V16.0875H234.998C235.228 16.0875 235.416 15.9003 235.416 15.6702C235.416 15.4401 235.228 15.2529 234.998 15.2529H213.216V0.417938C213.216 0.187851 213.028 0.000656128 212.798 0.000656128C212.568 0.000656128 212.381 0.187851 212.381 0.417938V15.2529H174.847V0.417938C174.847 0.187851 174.66 0.000656128 174.43 0.000656128C174.2 0.000656128 174.012 0.187851 174.012 0.417938V15.2529H17.7302V0.417938C17.7302 0.187851 17.5429 0.000656128 17.3129 0.000656128C17.0828 0.000656128 16.8956 0.187851 16.8956 0.417938V15.2529H6.82227C6.59216 15.2529 6.405 15.4401 6.405 15.6702C6.405 15.9003 6.59216 16.0875 6.82227 16.0875ZM41.0317 16.0875H154.505V31.369H41.0317V16.0875ZM96.3627 47.8186V32.2036H134.846V47.8186H96.3627ZM79.1332 64.935V48.6531H116.402V64.935H79.1332ZM95.5281 32.2036V47.8186H57.0445V32.2036H95.5281ZM17.7263 32.2036H56.2099V47.8186H17.7263V32.2036ZM41.0298 48.6531H78.2986V64.935H41.0298V48.6531ZM57.0445 65.7695H95.5281V81.5912H57.0445V65.7695ZM134.846 81.5912H96.3627V65.7695H134.846V81.5912ZM154.505 64.9369H117.237V48.6551H154.505V64.9369ZM174.011 47.8205H135.681V32.2055H174.011V47.8205ZM197.137 31.371H155.34V16.0895H197.137V31.371Z",
    fill: "#E9EAFD"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3236_4714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.656 9.69531H65.4314V189.695H183.656V9.69531Z",
    fill: "#9EA2F5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M183.656 9.69531H65.4314V189.695H183.656V9.69531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M183.656 9.69531H137.741V189.695H183.656V9.69531Z",
    fill: "black",
    fillOpacity: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M133.869 106.012H68.8916V170.989H133.869V106.012Z",
    fill: "black",
    fillOpacity: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M133.863 106.012H117.452V170.989H133.863V106.012Z",
    fill: "black",
    fillOpacity: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M68.8916 106.012L87.8738 124.994H117.452H133.869V106.012H68.8916Z",
    fill: "black",
    fillOpacity: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M133.869 35.5312H68.8917V100.509H133.869V35.5312Z",
    fill: "black",
    fillOpacity: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.017 35.5312H68.8917V100.509H132.017V35.5312Z",
    fill: "#9EA2F5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M132.017 35.5312H68.8917V100.509H132.017V35.5312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.12 43.3047H86.5487V49.127H109.12V43.3047Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M118.955 72.206L112.979 64.3223H111.789V69.6721H110.212L112.237 72.1998C112.323 72.3041 112.249 72.4636 112.108 72.4636H95.0889C94.7883 72.4636 94.4999 72.3225 94.3159 72.0771L92.4876 69.6721H85.6653L90.5918 75.8196C90.7759 76.0466 91.052 76.1816 91.3526 76.1816H118.176C118.709 76.1816 119.145 75.746 119.145 75.2122V72.7888C119.145 72.5741 119.077 72.3716 118.949 72.1998L118.955 72.206Z",
    fill: "black",
    fillOpacity: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2173 63.9297H112.175C112.703 63.9297 113.126 64.353 113.126 64.8806V69.5311C113.126 70.0587 112.703 70.4821 112.175 70.4821H80.2173C79.6897 70.4821 79.2664 70.0587 79.2664 69.5311V64.8806C79.2664 64.353 79.6897 63.9297 80.2173 63.9297Z",
    fill: "#9EA2F5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M80.2173 63.9297H104.531C105.059 63.9297 105.482 64.353 105.482 64.8806V69.5311C105.482 70.0587 105.059 70.4821 104.531 70.4821H80.2173C79.6897 70.4821 79.2664 70.0587 79.2664 69.5311V64.8806C79.2664 64.353 79.6897 63.9297 80.2173 63.9297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M133.869 137L137.741 141.816V189.695H79.7386L65.4314 173.928L133.869 137Z",
    fill: "black",
    fillOpacity: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2109 145.735L133.869 136.998V168.392L80.4319 178.619L76.2109 145.735Z",
    fill: "#C0C3FC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M76.2109 145.735L133.869 136.998V168.392L80.4319 178.619L76.2109 145.735Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M76.2109 145.735L77.0208 146.624L133.869 137.882V136.998L76.2109 145.735Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M85.6714 144.305L88.2727 144.894L90.4139 176.711L80.4319 178.619L76.2109 145.734L85.6714 144.305Z",
    fill: "black",
    fillOpacity: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6713 182.754H20.6998L16.6138 118.746H81.5914L85.6713 182.754Z",
    fill: "#C0C3FC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M85.6713 182.754H20.6998L16.6138 118.746H81.5914L85.6713 182.754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M85.6714 182.754H83.8247L79.7386 118.746H81.5915L85.6714 182.754Z",
    fill: "black",
    fillOpacity: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6949 132.145H35.1236L34.7555 126.402H57.333L57.6949 132.145Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M68.9837 154.874L62.5111 147.113H61.327L61.6644 152.383H60.0877L62.2718 154.874C62.3639 154.979 62.2964 155.132 62.1614 155.132H45.1424C44.8418 155.132 44.5412 154.991 44.3448 154.752L42.3693 152.383H35.547L40.8601 158.439C41.0564 158.666 41.3447 158.795 41.6392 158.795H68.4622C68.996 158.795 69.407 158.365 69.3702 157.838L69.2169 155.451C69.2046 155.242 69.1187 155.04 68.9837 154.874Z",
    fill: "black",
    fillOpacity: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0939 153.181H30.1357C29.6081 153.181 29.1602 152.764 29.1234 152.242L28.8289 147.659C28.7983 147.144 29.197 146.721 29.7185 146.721H61.6767C62.2043 146.721 62.6522 147.138 62.689 147.659L62.9835 152.242C63.0141 152.758 62.6154 153.181 62.0939 153.181Z",
    fill: "#C0C3FC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M54.4494 153.181H30.1357C29.6081 153.181 29.1602 152.764 29.1234 152.242L28.8289 147.659C28.7983 147.144 29.197 146.721 29.7185 146.721H54.0322C54.5599 146.721 55.0077 147.138 55.0445 147.659L55.339 152.242C55.3697 152.758 54.9709 153.181 54.4494 153.181Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3236_4714"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3236_4714"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 167.042,
    height: 180,
    fill: "white",
    transform: "translate(16.6138 9.69531)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTableToDisplay);
export default __webpack_public_path__ + "static/media/NoTableToDisplay.727b5df7457f57d0818387759a239138.svg";
export { ForwardRef as ReactComponent };